import { useState } from "react";
import type { ImageBackupFileItem } from "../../view/contents/image/image.drive";
import styled from "styled-components";
import ImageDrive from "../../view/contents/image/image.drive";
import type { DeviceItem } from "../../view/contents/backup/backup.device.list";
import ModalCenterLayout from "../modal/modal.center.layout";

interface Props {
  device: DeviceItem;
  onClose: () => void;
}

const ImageBackupModal = ({ device, onClose }: Props) => {
  const [history, setHistory] = useState<
    { file: ImageBackupFileItem; directoryPath: string }[]
  >([]);
  const current = history[history.length - 1];
  return (
    <ModalCenterLayout isVisible closedHandler={onClose} size="l">
      <Contents
        role="dialog"
        aria-modal="true"
        aria-labelledby="image-backup-title"
      >
        <div className="image-modal-header">
          <div className="image-modal-title">
            <h3 id="image-backup-title">이미지 백업 목록</h3>
          </div>
          <button
            type="button"
            aria-label="이미지 백업 목록 닫기"
            onClick={onClose}
          >
            ×
          </button>
        </div>
        <ImageDrive
          canGoBack={history.length > 0}
          onBack={() => setHistory(previous => previous.slice(0, -1))}
          onOpenImage={(file, directoryPath) =>
            setHistory([{ file, directoryPath }])
          }
          contentsContext={
            current
              ? {
                  targetUserId: current.file.userId,
                  targetDeviceId: current.file.deviceId,
                  diskBackupStamp: current.file.backupStamp,
                  directoryPath: current.directoryPath,
                }
              : undefined
          }
          onFolderClick={(directoryPath) =>
            setHistory((previous) => {
              const last = previous[previous.length - 1];
              return last.directoryPath === directoryPath
                ? previous
                : [...previous, { file: last.file, directoryPath }];
            })
          }
          context={{
            userId: device.userId,
            deviceId: device.deviceId,
            userAccount: device.userAccount,
            pcName: device.pcName,
          }}
        />
      </Contents>
    </ModalCenterLayout>
  );
};

const Contents = styled.div`
  max-height: 85vh;
  overflow: auto;
  background: white;
  .image-modal-title {
    display: flex;
    align-items: center;
    gap: 1rem;
  }
  .back-trigger {
    display: inline-flex;
  }
  .back-trigger button:disabled {
    opacity: 0.35;
    cursor: default;
  }
  .image-modal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1.6rem 2rem;
    background: #333333;
    color: white;
    h3 {
      font-size: 1.8rem;
    }
    button {
      border: 0;
      background: none;
      color: white;
      font-size: 2.4rem;
      cursor: pointer;
    }
  }
  .image-device-name {
    padding: 1.6rem 2rem 0;
    font-size: 1.4rem;
  }
  .file-list-container {
    height: auto;
    padding: 2rem;
  }
`;

export default ImageBackupModal;
